/** Customer-provider cadence. Keep vercel.json and its contract test aligned. */
export const CONDITIONS_REFRESH_HOURS = 3;
/** Allow two hours for staggered slices, provider pacing and delayed cron starts. */
export const CONDITIONS_STALE_HOURS = CONDITIONS_REFRESH_HOURS + 2;
